<template>
    <StfBody>
        <component :is="layout">
            <router-view />
        </component>
    </StfBody>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {useRoute} from 'vue-router';
import {ApplicationProcessLayoutName} from '@/layouts/global-component';
import useDomainFavicon from './composables/domainFaviconable';
import useDomain from './composables/domainDependable';
import type { Domain } from './config/domain/type';
const DEFAULT_LAYOUT = ApplicationProcessLayoutName;

const route = useRoute();

const domain = useDomain();
window.document.title = domain.title;

useDomainFavicon();

const layout = computed(() => {
    return route.meta.layout || DEFAULT_LAYOUT;
});

const updateMetaDescription = (domain: Domain) => {
    const description = window.document.querySelector('meta[name="description"]');

    if (null == description) {
        return;
    }

    description.setAttribute('content', domain.description);
}

updateMetaDescription(domain);

const setTheme = function (domain: Domain): void {
    const app = document.getElementById('app') as HTMLElement;

    app.className = domain.shortCode;
};

setTheme(domain);

</script>
